import React from 'react';
interface CTAButtonProps {
  children: React.ReactNode;
  href?: string;
  onClick?: () => void;
  className?: string;
  size?: 'normal' | 'large';
}
export function CTAButton({
  children,
  href = 'https://checkout.empezahoy.shop/cart/48089967624424:1',
  onClick,
  className = '',
  size = 'normal'
}: CTAButtonProps) {
  const sizeClasses = size === 'large' ? 'px-10 py-5 text-xl md:text-2xl' : 'px-8 py-4 text-lg';
  const baseClasses = `
    inline-block
    bg-gradient-to-r from-red-600 via-red-500 to-red-600
    hover:from-red-500 hover:via-red-400 hover:to-red-500
    text-white font-bold
    rounded-lg
    transition-all duration-300
    transform hover:scale-105
    cta-pulse
    shadow-lg
    uppercase tracking-wide
    text-center
    cursor-pointer
    ${sizeClasses}
    ${className}
  `;
  if (href) {
    return <a href={href} className={baseClasses} onClick={onClick} data-id="element-51">
        {children}
      </a>;
  }
  return <button className={baseClasses} onClick={onClick} data-id="element-52">
      {children}
    </button>;
}